const p = new TextDecoder(), Z = new TextEncoder();
class U extends Error {
  /**
   * Creates a new instance.
   * @param methodName The name of the method that was missing.
   */
  constructor(g) {
    super(`Method "${g}" does not exist on impl.`);
  }
}
class z extends Error {
  /**
   * Creates a new instance.
   * @param methodName The name of the method that was missing.
   */
  constructor(g) {
    super(`Method "${g}" is not supported on this impl.`);
  }
}
class L extends Error {
  /**
   * Creates a new instance.
   */
  constructor() {
    super("Implementation already set.");
  }
}
function y(A) {
  if (!A || !(A instanceof URL) && typeof A != "string")
    throw new TypeError("Path must be a non-empty string or URL.");
}
function h(A) {
  if (typeof A != "string" && !(A instanceof ArrayBuffer) && !ArrayBuffer.isView(A))
    throw new TypeError(
      "File contents must be a string, ArrayBuffer, or ArrayBuffer view."
    );
}
function d(A) {
  if (A instanceof Uint8Array)
    return A;
  if (typeof A == "string")
    return Z.encode(A);
  if (A instanceof ArrayBuffer)
    return new Uint8Array(A);
  if (ArrayBuffer.isView(A)) {
    const g = A.buffer.slice(
      A.byteOffset,
      A.byteOffset + A.byteLength
    );
    return new Uint8Array(g);
  }
  throw new TypeError(
    "Invalid contents type. Expected string or ArrayBuffer."
  );
}
class Q {
  /**
   * The type of log entry.
   * @type {string}
   */
  type;
  /**
   * The data associated with the log entry.
   * @type {any}
   */
  data;
  /**
   * The time at which the log entry was created.
   * @type {number}
   */
  timestamp = Date.now();
  /**
   * Creates a new instance.
   * @param {string} type The type of log entry.
   * @param {any} [data] The data associated with the log entry.
   */
  constructor(g, I) {
    this.type = g, this.data = I;
  }
}
class V {
  /**
   * The base implementation for this instance.
   */
  #g;
  /**
   * The current implementation for this instance.
   */
  #A;
  /**
   * A map of log names to their corresponding entries.
   */
  #C = /* @__PURE__ */ new Map();
  /**
   * Creates a new instance.
   * @param {object} options The options for the instance.
   * @param {HfsImpl} options.impl The implementation to use.
   */
  constructor({ impl: g }) {
    this.#g = g, this.#A = g;
  }
  /**
   * Logs an entry onto all currently open logs.
   * @param {string} methodName The name of the method being called.
   * @param {...*} args The arguments to the method.
   * @returns {void}
   */
  #i(g, ...I) {
    for (const i of this.#C.values())
      i.push(new Q("call", { methodName: g, args: I }));
  }
  /**
   * Starts a new log with the given name.
   * @param {string} name The name of the log to start;
   * @returns {void}
   * @throws {Error} When the log already exists.
   * @throws {TypeError} When the name is not a non-empty string.
   */
  logStart(g) {
    if (!g || typeof g != "string")
      throw new TypeError("Log name must be a non-empty string.");
    if (this.#C.has(g))
      throw new Error(`Log "${g}" already exists.`);
    this.#C.set(g, []);
  }
  /**
   * Ends a log with the given name and returns the entries.
   * @param {string} name The name of the log to end.
   * @returns {Array<LogEntry>} The entries in the log.
   * @throws {Error} When the log does not exist.
   */
  logEnd(g) {
    if (this.#C.has(g)) {
      const I = this.#C.get(g);
      return this.#C.delete(g), I;
    }
    throw new Error(`Log "${g}" does not exist.`);
  }
  /**
   * Determines if the current implementation is the base implementation.
   * @returns {boolean} True if the current implementation is the base implementation.
   */
  isBaseImpl() {
    return this.#A === this.#g;
  }
  /**
   * Sets the implementation for this instance.
   * @param {object} impl The implementation to use.
   * @returns {void}
   */
  setImpl(g) {
    if (this.#i("implSet", g), this.#A !== this.#g)
      throw new L();
    this.#A = g;
  }
  /**
   * Resets the implementation for this instance back to its original.
   * @returns {void}
   */
  resetImpl() {
    this.#i("implReset"), this.#A = this.#g;
  }
  /**
   * Asserts that the given method exists on the current implementation.
   * @param {string} methodName The name of the method to check.
   * @returns {void}
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   */
  #D(g) {
    if (typeof this.#A[g] != "function")
      throw new U(g);
  }
  /**
   * Asserts that the given method exists on the current implementation, and if not,
   * throws an error with a different method name.
   * @param {string} methodName The name of the method to check.
   * @param {string} targetMethodName The name of the method that should be reported
   *  as an error when methodName does not exist.
   * @returns {void}
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   */
  #w(g, I) {
    if (typeof this.#A[g] != "function")
      throw new z(I);
  }
  /**
   * Calls the given method on the current implementation.
   * @param {string} methodName The name of the method to call.
   * @param {...any} args The arguments to the method.
   * @returns {any} The return value from the method.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   */
  #I(g, ...I) {
    return this.#i(g, ...I), this.#D(g), this.#A[g](...I);
  }
  /**
   * Calls the given method on the current implementation and doesn't log the call.
   * @param {string} methodName The name of the method to call.
   * @param {...any} args The arguments to the method.
   * @returns {any} The return value from the method.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   */
  #B(g, ...I) {
    return this.#D(g), this.#A[g](...I);
  }
  /**
   * Calls the given method on the current implementation but logs a different method name.
   * @param {string} methodName The name of the method to call.
   * @param {string} targetMethodName The name of the method to log.
   * @param {...any} args The arguments to the method.
   * @returns {any} The return value from the method.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   */
  #e(g, I, ...i) {
    return this.#i(I, ...i), this.#w(g, I), this.#A[g](...i);
  }
  /**
   * Reads the given file and returns the contents as text. Assumes UTF-8 encoding.
   * @param {string|URL} filePath The file to read.
   * @returns {Promise<string|undefined>} The contents of the file.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the file path is not a non-empty string.
   */
  async text(g) {
    y(g);
    const I = await this.#e("bytes", "text", g);
    return I ? p.decode(I) : void 0;
  }
  /**
   * Reads the given file and returns the contents as JSON. Assumes UTF-8 encoding.
   * @param {string|URL} filePath The file to read.
   * @returns {Promise<any|undefined>} The contents of the file as JSON.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {SyntaxError} When the file contents are not valid JSON.
   * @throws {TypeError} When the file path is not a non-empty string.
   */
  async json(g) {
    y(g);
    const I = await this.#e("bytes", "json", g);
    return I ? JSON.parse(p.decode(I)) : void 0;
  }
  /**
   * Reads the given file and returns the contents as an ArrayBuffer.
   * @param {string|URL} filePath The file to read.
   * @returns {Promise<ArrayBuffer|undefined>} The contents of the file as an ArrayBuffer.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the file path is not a non-empty string.
   * @deprecated Use bytes() instead.
   */
  async arrayBuffer(g) {
    return y(g), (await this.#e(
      "bytes",
      "arrayBuffer",
      g
    ))?.buffer;
  }
  /**
   * Reads the given file and returns the contents as an Uint8Array.
   * @param {string|URL} filePath The file to read.
   * @returns {Promise<Uint8Array|undefined>} The contents of the file as an Uint8Array.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the file path is not a non-empty string.
   */
  async bytes(g) {
    return y(g), this.#I("bytes", g);
  }
  /**
   * Writes the given data to the given file. Creates any necessary directories along the way.
   * If the data is a string, UTF-8 encoding is used.
   * @param {string|URL} filePath The file to write.
   * @param {string|ArrayBuffer|ArrayBufferView} contents The data to write.
   * @returns {Promise<void>} A promise that resolves when the file is written.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the file path is not a non-empty string.
   */
  async write(g, I) {
    y(g), h(I), this.#i("write", g, I);
    const i = d(I);
    return this.#B("write", g, i);
  }
  /**
   * Appends the given data to the given file. Creates any necessary directories along the way.
   * If the data is a string, UTF-8 encoding is used.
   * @param {string|URL} filePath The file to append to.
   * @param {string|ArrayBuffer|ArrayBufferView} contents The data to append.
   * @returns {Promise<void>} A promise that resolves when the file is appended to.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the file path is not a non-empty string.
   * @throws {TypeError} When the file contents are not a string or ArrayBuffer.
   * @throws {Error} When the file cannot be appended to.
   */
  async append(g, I) {
    y(g), h(I), this.#i("append", g, I);
    const i = d(I);
    return this.#B("append", g, i);
  }
  /**
   * Determines if the given file exists.
   * @param {string|URL} filePath The file to check.
   * @returns {Promise<boolean>} True if the file exists.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the file path is not a non-empty string.
   */
  async isFile(g) {
    return y(g), this.#I("isFile", g);
  }
  /**
   * Determines if the given directory exists.
   * @param {string|URL} dirPath The directory to check.
   * @returns {Promise<boolean>} True if the directory exists.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the directory path is not a non-empty string.
   */
  async isDirectory(g) {
    return y(g), this.#I("isDirectory", g);
  }
  /**
   * Creates the given directory.
   * @param {string|URL} dirPath The directory to create.
   * @returns {Promise<void>} A promise that resolves when the directory is created.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the directory path is not a non-empty string.
   */
  async createDirectory(g) {
    return y(g), this.#I("createDirectory", g);
  }
  /**
   * Deletes the given file or empty directory.
   * @param {string|URL} filePath The file to delete.
   * @returns {Promise<boolean>} A promise that resolves when the file or
   *   directory is deleted, true if the file or directory is deleted, false
   *   if the file or directory does not exist.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the file path is not a non-empty string.
   */
  async delete(g) {
    return y(g), this.#I("delete", g);
  }
  /**
   * Deletes the given file or directory recursively.
   * @param {string|URL} dirPath The directory to delete.
   * @returns {Promise<boolean>} A promise that resolves when the file or
   *   directory is deleted, true if the file or directory is deleted, false
   *   if the file or directory does not exist.
   * @throws {NoSuchMethodError} When the method does not exist on the current implementation.
   * @throws {TypeError} When the directory path is not a non-empty string.
   */
  async deleteAll(g) {
    return y(g), this.#I("deleteAll", g);
  }
  /**
   * Returns a list of directory entries for the given path.
   * @param {string|URL} dirPath The path to the directory to read.
   * @returns {AsyncIterable<HfsDirectoryEntry>} A promise that resolves with the
   *   directory entries.
   * @throws {TypeError} If the directory path is not a string or URL.
   * @throws {Error} If the directory cannot be read.
   */
  async *list(g) {
    y(g), yield* await this.#I("list", g);
  }
  /**
   * Walks a directory using a depth-first traversal and returns the entries
   * from the traversal.
   * @param {string|URL} dirPath The path to the directory to walk.
   * @param {Object} [options] The options for the walk.
   * @param {(entry:HfsWalkEntry) => Promise<boolean>|boolean} [options.directoryFilter] A filter function to determine
   * 	if a directory's entries should be included in the walk.
   * @param {(entry:HfsWalkEntry) => Promise<boolean>|boolean} [options.entryFilter] A filter function to determine if
   * 	an entry should be included in the walk.
   * @returns {AsyncIterable<HfsWalkEntry>} A promise that resolves with the
   * 	directory entries.
   * @throws {TypeError} If the directory path is not a string or URL.
   * @throws {Error} If the directory cannot be read.
   */
  async *walk(g, { directoryFilter: I = () => !0, entryFilter: i = () => !0 } = {}) {
    y(g), this.#i("walk", g, { directoryFilter: I, entryFilter: i });
    const C = (async function* (B, { directoryFilter: e, entryFilter: D, parentPath: w = "", depth: M = 1 }) {
      let S;
      try {
        S = await this.#B(
          "list",
          B
        );
      } catch (P) {
        if (P.code === "ENOENT")
          return;
        throw P;
      }
      for await (const P of S) {
        const r = {
          path: P.name,
          depth: M,
          ...P
        };
        w && (r.path = `${w}/${r.path}`);
        let n = D(r);
        if (n.then && (n = await n), n && (yield r), P.isDirectory) {
          let G = e(r);
          if (G.then && (G = await G), !G)
            continue;
          const T = B instanceof URL ? new URL(
            P.name,
            B.href.endsWith("/") ? B.href : `${B.href}/`
          ) : `${B.endsWith("/") ? B : `${B}/`}${P.name}`;
          yield* C(T, {
            directoryFilter: e,
            entryFilter: D,
            parentPath: r.path,
            depth: M + 1
          });
        }
      }
    }).bind(this);
    yield* C(g, { directoryFilter: I, entryFilter: i });
  }
  /**
   * Returns the size of the given file.
   * @param {string|URL} filePath The path to the file to read.
   * @returns {Promise<number>} A promise that resolves with the size of the file.
   * @throws {TypeError} If the file path is not a string or URL.
   * @throws {Error} If the file cannot be read.
   */
  async size(g) {
    return y(g), this.#I("size", g);
  }
  /**
   * Returns the last modified timestamp of the given file or directory.
   * @param {string|URL} fileOrDirPath The path to the file or directory.
   * @returns {Promise<Date|undefined>} A promise that resolves with the last modified date
   *  or undefined if the file or directory does not exist.
   * @throws {TypeError} If the path is not a string or URL.
   */
  async lastModified(g) {
    return y(g), this.#I("lastModified", g);
  }
  /**
   * Copys a file from one location to another.
   * @param {string|URL} source The path to the file to copy.
   * @param {string|URL} destination The path to the new file.
   * @returns {Promise<void>} A promise that resolves when the file is copied.
   * @throws {TypeError} If the file path is not a string or URL.
   * @throws {Error} If the file cannot be copied.
   */
  async copy(g, I) {
    return y(g), y(I), this.#I("copy", g, I);
  }
  /**
   * Copies a file or directory from one location to another.
   * @param {string|URL} source The path to the file or directory to copy.
   * @param {string|URL} destination The path to copy the file or directory to.
   * @returns {Promise<void>} A promise that resolves when the file or directory is
   * copied.
   * @throws {TypeError} If the directory path is not a string or URL.
   * @throws {Error} If the directory cannot be copied.
   */
  async copyAll(g, I) {
    return y(g), y(I), this.#I("copyAll", g, I);
  }
  /**
   * Moves a file from the source path to the destination path.
   * @param {string|URL} source The location of the file to move.
   * @param {string|URL} destination The destination of the file to move.
   * @returns {Promise<void>} A promise that resolves when the move is complete.
   * @throws {TypeError} If the file or directory paths are not strings.
   * @throws {Error} If the file or directory cannot be moved.
   */
  async move(g, I) {
    return y(g), y(I), this.#I("move", g, I);
  }
  /**
   * Moves a file or directory from one location to another.
   * @param {string|URL} source The path to the file or directory to move.
   * @param {string|URL} destination The path to move the file or directory to.
   * @returns {Promise<void>} A promise that resolves when the file or directory is
   * moved.
   * @throws {TypeError} If the source is not a string or URL.
   * @throws {TypeError} If the destination is not a string or URL.
   * @throws {Error} If the file or directory cannot be moved.
   */
  async moveAll(g, I) {
    return y(g), y(I), this.#I("moveAll", g, I);
  }
}
class t {
  /**
   * The steps in the path.
   */
  #g;
  /**
   * Creates a new instance.
   * @param steps The steps to use for the path.
   * @throws {TypeError} When steps is not iterable.
   */
  constructor(g = []) {
    if (typeof g[Symbol.iterator] != "function")
      throw new TypeError("steps must be iterable");
    this.#g = [...g], this.#g.forEach(H);
  }
  /**
   * Adds steps to the end of the path.
   * @param steps The steps to add to the path.
   */
  push(...g) {
    g.forEach(H), this.#g.push(...g);
  }
  /**
   * Removes the last step from the path.
   * @returns The last step in the path.
   */
  pop() {
    return this.#g.pop();
  }
  /**
   * Returns an iterator for steps in the path.
   * @returns An iterator for the steps in the path.
   */
  steps() {
    return this.#g.values();
  }
  /**
   * Returns an iterator for the steps in the path.
   * @returns An iterator for the steps in the path.
   */
  [Symbol.iterator]() {
    return this.steps();
  }
  /**
   * Retrieves the name (the last step) of the path.
   */
  get name() {
    return this.#g[this.#g.length - 1];
  }
  /**
   * Sets the name (the last step) of the path.
   */
  set name(g) {
    H(g), this.#g[this.#g.length - 1] = g;
  }
  /**
   * Retrieves the size of the path.
   */
  get size() {
    return this.#g.length;
  }
  /**
   * Returns the path as a string.
   * @returns The path as a string.
   */
  toString() {
    return this.#g.join("/");
  }
  /**
   * Creates a new path based on the argument type. If the argument is a string,
   * it is assumed to be a file or directory path and is converted to a Path
   * instance. If the argument is a URL, it is assumed to be a file URL and is
   * converted to a Path instance. If the argument is a Path instance, it is
   * copied into a new Path instance. If the argument is an array, it is assumed
   * to be the steps of a path and is used to create a new Path instance.
   * @param pathish The value to convert to a Path instance.
   * @returns A new Path instance.
   * @throws {TypeError} When pathish is not a string, URL, Path, or Array.
   * @throws {TypeError} When pathish is a string and is empty.
   */
  static from(g) {
    if (typeof g == "string") {
      if (!g)
        throw new TypeError("argument cannot be empty");
      return t.fromString(g);
    }
    if (g instanceof URL)
      return t.fromURL(g);
    if (g instanceof t || Array.isArray(g))
      return new t(g);
    throw new TypeError("argument must be a string, URL, Path, or Array");
  }
  /**
   * Creates a new Path instance from a string.
   * @param fileOrDirPath The file or directory path to convert.
   * @returns A new Path instance.
   * @deprecated Use Path.from() instead.
   */
  static fromString(g) {
    return new t(f(g).split("/"));
  }
  /**
   * Creates a new Path instance from a URL.
   * @param url The URL to convert.
   * @returns A new Path instance.
   * @throws {TypeError} When url is not a URL instance.
   * @throws {TypeError} When url.pathname is empty.
   * @throws {TypeError} When url.protocol is not "file:".
   * @deprecated Use Path.from() instead.
   */
  static fromURL(g) {
    if (!(g instanceof URL))
      throw new TypeError("url must be a URL instance");
    if (!g.pathname || g.pathname === "/")
      throw new TypeError("url.pathname cannot be empty");
    if (g.protocol !== "file:")
      throw new TypeError('url.protocol must be "file:"');
    return new t(f(g.pathname.slice(1)).split("/"));
  }
}
function f(A) {
  let g = 0, I = A.length;
  return /[a-z]:\//i.test(A) && (g = 3), A.startsWith("./") && (g = 2), A.startsWith("/") && (g = 1), A.endsWith("/") && (I = A.length - 1), A.slice(g, I).replace(/\\/g, "/");
}
function H(A) {
  if (typeof A != "string")
    throw new TypeError("name must be a string");
  if (!A)
    throw new TypeError("name cannot be empty");
  if (A === ".")
    throw new TypeError('name cannot be "."');
  if (A === "..")
    throw new TypeError('name cannot be ".."');
  if (A.includes("/") || A.includes("\\"))
    throw new TypeError(
      `name cannot contain a slash or backslash: "${A}"`
    );
}
class a extends Error {
  name = "NotFoundError";
  code = "ENOENT";
  constructor(g) {
    super(`ENOENT: No such file or directory, ${g}`);
  }
}
class K extends Error {
  name = "DirectoryError";
  code = "EISDIR";
  constructor(g) {
    super(`EISDIR: Illegal operation on a directory, ${g}`);
  }
}
class R extends Error {
  name = "NotEmptyError";
  code = "ENOTEMPTY";
  constructor(g) {
    super(`ENOTEMPTY: Directory not empty, ${g}`);
  }
}
class J {
  /**
   * The root directory to work on.
   */
  #g;
  /**
   * Creates a new instance.
   */
  constructor({ root: g }) {
    if (!g)
      throw new TypeError("options.root is required");
    this.#g = g;
  }
  /**
   * Reads a file and returns the contents as an Uint8Array.
   */
  async bytes(g) {
    const I = await O(this.#g, g);
    return I ? new Uint8Array(I) : void 0;
  }
  /**
   * Writes a value to a file. If the value is a string, UTF-8 encoding is used.
   */
  async write(g, I) {
    let i = await o(this.#g, g);
    if (!i) {
      const e = t.from(g).name;
      i = await (await o(this.#g, g, {
        create: !0,
        kind: "directory",
        returnParent: !0
      }) ?? this.#g).getFileHandle(e, { create: !0 });
    }
    const C = await i.createWritable();
    await C.write(I), await C.close();
  }
  /**
   * Appends a value to a file. If the value is a string, UTF-8 encoding is used.
   */
  async append(g, I) {
    const i = await o(this.#g, g);
    if (!i)
      return this.write(g, I);
    if (i.kind !== "file")
      throw new K(`append '${g}'`);
    const C = await (await i.getFile()).arrayBuffer(), B = new Uint8Array([
      ...new Uint8Array(C),
      ...I
    ]);
    return this.write(g, B);
  }
  /**
   * Checks if a file exists.
   */
  async isFile(g) {
    const I = await o(this.#g, g);
    return !!(I && I.kind === "file");
  }
  /**
   * Checks if a directory exists.
   */
  async isDirectory(g) {
    const I = await o(this.#g, g);
    return !!(I && I.kind === "directory");
  }
  /**
   * Creates a directory recursively.
   */
  async createDirectory(g) {
    let I = this.#g;
    const i = t.from(g);
    for (const C of i)
      I = await I.getDirectoryHandle(C, { create: !0 });
  }
  /**
   * Deletes a file or empty directory.
   */
  async delete(g) {
    const I = await o(this.#g, g), i = await o(this.#g, g, {
      returnParent: !0
    }) ?? this.#g;
    if (!I)
      return !1;
    if (I.kind === "directory" && !(await I.values().next()).done)
      throw new R(`delete '${g}'`);
    return i.removeEntry(I.name), !0;
  }
  /**
   * Deletes a file or directory recursively.
   */
  async deleteAll(g) {
    const I = await o(this.#g, g);
    if (!I)
      return !1;
    if (I.remove)
      return await I.remove({ recursive: !0 }), !0;
    const i = await o(this.#g, g, {
      returnParent: !0
    }) ?? this.#g;
    if (!I)
      throw new a(`deleteAll '${g}'`);
    return i.removeEntry(I.name, { recursive: !0 }), !0;
  }
  /**
   * Returns a list of directory entries for the given path.
   */
  async *list(g) {
    const I = await o(this.#g, g);
    if (!I)
      return;
    const i = await $();
    for await (const C of I.values()) {
      const B = C.kind === "file", e = C.kind === "directory", D = !1;
      let w;
      try {
        w = await v(i, `${g}/${C.name}`, B);
      } catch (M) {
        console.warn(`>> [fs:web] failed to read metadata for "${g}/${C.name}":`, M);
      }
      yield {
        name: C.name,
        size: w?.size ?? 0,
        lastModified: w?.modificationTime ?? /* @__PURE__ */ new Date(),
        isFile: B,
        isSymlink: D,
        isDirectory: e
      };
    }
  }
  /**
   * Returns the size of a file.
   */
  async size(g) {
    const I = await o(this.#g, g);
    return !I || I.kind !== "file" ? void 0 : (await I.getFile()).size;
  }
  /**
   * Returns the last modified date of a file or directory. This method handles ENOENT errors
   * and returns undefined in that case.
   */
  async lastModified(g) {
    const I = await o(this.#g, g);
    if (!I)
      return;
    if (I.kind === "file") {
      const B = await I.getFile();
      return new Date(B.lastModified);
    }
    let i = /* @__PURE__ */ new Date(0);
    for await (const C of this.list(g)) {
      const B = t.from(g);
      B.push(C.name);
      const e = await this.lastModified(B.toString());
      e && e > i && (i = e);
    }
    return i.getTime() === 0 ? /* @__PURE__ */ new Date() : i;
  }
  /**
   * Copies a file from one location to another.
   */
  async copy(g, I) {
    const i = await o(this.#g, g);
    if (!i)
      throw new a(`copy '${g}' -> '${I}'`);
    if (i.kind !== "file")
      throw new K(`copy '${g}' -> '${I}'`);
    if (await this.isDirectory(I))
      throw new K(`copy '${g}' -> '${I}'`);
    const C = await o(this.#g, I, {
      create: !0,
      kind: "file"
    }), B = await i.getFile(), e = await C.createWritable();
    await e.write(B), await e.close();
  }
  /**
   * Copies a file or directory from one location to another.
   */
  async copyAll(g, I) {
    if (await this.isFile(g))
      return this.copy(g, I);
    if (!await this.isDirectory(g))
      throw new a(`copyAll '${g}' -> '${I}'`);
    const i = t.from(g), C = t.from(I);
    await this.createDirectory(I);
    for await (const B of this.list(g))
      C.push(B.name), i.push(B.name), B.isDirectory ? await this.copyAll(
        i.toString(),
        C.toString()
      ) : await this.copy(
        i.toString(),
        C.toString()
      ), C.pop(), i.pop();
  }
  /**
   * Moves a file from the source path to the destination path.
   */
  async move(g, I) {
    const i = await o(this.#g, g);
    if (!i)
      throw new a(`move '${g}' -> '${I}'`);
    if (i.kind !== "file")
      throw new K(`move '${g}' -> '${I}'`);
    const C = i, B = t.from(I), e = B.pop(), D = await o(
      this.#g,
      B.toString(),
      { create: !0, kind: "directory" }
    ), w = async (M) => {
      if (M.name === "NotAllowedError") {
        await this.copy(g, I), await this.delete(g);
        return;
      }
      throw M;
    };
    return C.move(D, e).catch(w);
  }
  /**
   * Moves a file or directory from one location to another.
   */
  async moveAll(g, I) {
    const i = await o(this.#g, g);
    if (!i)
      throw new a(`moveAll '${g}' -> '${I}'`);
    if (i.kind === "file")
      return this.move(g, I);
    const C = i, B = t.from(I);
    if (C.move) {
      const D = B.pop(), w = await o(
        this.#g,
        B.toString(),
        { create: !0, kind: "directory" }
      );
      return C.move(w, D);
    }
    const e = t.from(g);
    await this.createDirectory(I);
    for await (const D of this.list(g))
      B.push(D.name), e.push(D.name), D.isDirectory ? await this.moveAll(
        e.toString(),
        B.toString()
      ) : await this.move(
        e.toString(),
        B.toString()
      ), B.pop(), e.pop();
    await this.delete(g);
  }
}
class W extends V {
  /** Creates a new instance. */
  constructor({ root: g }) {
    super({ impl: new J({ root: g }) });
  }
}
const E = async () => new W({ root: await navigator.storage.getDirectory() });
async function o(A, g, { returnParent: I = !1, create: i = !1, kind: C } = {}) {
  if (g === ".")
    return A;
  const e = [...t.from(g)];
  I && e.pop();
  let D = A, w = e.shift();
  for (; D && w; ) {
    if (e.length > 0)
      try {
        D = await D.getDirectoryHandle(w, { create: i });
      } catch {
        return;
      }
    else {
      if (!C)
        try {
          return await D.getDirectoryHandle(w, { create: i });
        } catch {
          try {
            return await D.getFileHandle(w, { create: i });
          } catch {
            return;
          }
        }
      if (C === "directory")
        try {
          return await D.getDirectoryHandle(w, { create: i });
        } catch {
          return;
        }
      if (C === "file")
        try {
          return await D.getFileHandle(w, { create: i });
        } catch {
          return;
        }
    }
    w = e.shift();
  }
}
async function O(A, g, I) {
  const i = await o(A, g);
  return !i || i.kind !== "file" ? void 0 : (await i.getFile()).arrayBuffer();
}
async function v(A, g, I) {
  return I ? new Promise((B, e) => {
    A.getFile(g, {}, (D) => D.getMetadata(B, e), e);
  }) : new Promise((B, e) => {
    A.getDirectory(g, {}, (D) => D.getMetadata(B, e), e);
  });
}
async function $() {
  return await new Promise((A, g) => {
    try {
      webkitRequestFileSystem(0, 0, (I) => A(I.root), () => A());
    } catch (I) {
      g(I);
    }
  });
}
const Y = "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", q = (A) => Uint8Array.from(atob(A), (g) => g.charCodeAt(0)), b = typeof self < "u" && self.Blob && new Blob(["URL.revokeObjectURL(import.meta.url);", q(Y)], { type: "text/javascript;charset=utf-8" });
function _(A) {
  let g;
  try {
    if (g = b && (self.URL || self.webkitURL).createObjectURL(b), !g) throw "";
    const I = new Worker(g, {
      type: "module",
      name: A?.name
    });
    return I.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(g);
    }), I;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + Y,
      {
        type: "module",
        name: A?.name
      }
    );
  }
}
const j = /* @__PURE__ */ new Map();
async function gg(A, g, I) {
  const i = new _();
  return i.postMessage(A), I && j.set(I, i), new Promise((C, B) => {
    i.onmessage = (e) => {
      switch (e.data.type) {
        case "hash::progress": {
          const { bytes: D, total: w } = e.data.payload;
          g?.(D, w);
          break;
        }
        case "hash::complete": {
          C(e.data.payload), i.terminate(), I && j.delete(I);
          break;
        }
        case "hash::failure": {
          B(e.data.payload), i.terminate(), I && j.delete(I);
          break;
        }
      }
    }, i.onerror = (e) => {
      B(e.message ? e : new Error("Hash worker failed"));
    };
  });
}
async function Ig(A) {
  j.get(A)?.terminate();
}
const m = { start: gg, cancel: Ig }, Ag = [
  "dds",
  "eot",
  "gif",
  "ico",
  "jar",
  "jpeg",
  "jpg",
  "pdf",
  "png",
  "swf",
  "tga",
  "ttf",
  "zip"
], ig = [
  "Dockerfile",
  "Makefile",
  "Rakefile",
  "ada",
  "adb",
  "ads",
  "applescript",
  "as",
  "ascx",
  "asm",
  "asmx",
  "asp",
  "aspx",
  "atom",
  "bas",
  "bash",
  "bashrc",
  "bat",
  "bbcolors",
  "bdsgroup",
  "bdsproj",
  "bib",
  "bowerrc",
  "c",
  "cbl",
  "cc",
  "cfc",
  "cfg",
  "cfm",
  "cfml",
  "cgi",
  "clj",
  "cls",
  "cmake",
  "cmd",
  "cnf",
  "cob",
  "coffee",
  "coffeekup",
  "conf",
  "cpp",
  "cpt",
  "cpy",
  "crt",
  "cs",
  "csh",
  "cson",
  "csr",
  "css",
  "csslintrc",
  "csv",
  "ctl",
  "curlrc",
  "cxx",
  "dart",
  "dfm",
  "diff",
  "dockerignore",
  "dof",
  "dpk",
  "dproj",
  "dtd",
  "eco",
  "editorconfig",
  "ejs",
  "el",
  "emacs",
  "eml",
  "ent",
  "erb",
  "erl",
  "eslintignore",
  "eslintrc",
  "ex",
  "exs",
  "f",
  "f03",
  "f77",
  "f90",
  "f95",
  "fish",
  "for",
  "fpp",
  "frm",
  "ftn",
  "gemrc",
  "gitattributes",
  "gitconfig",
  "gitignore",
  "gitkeep",
  "gitmodules",
  "go",
  "gpp",
  "gradle",
  "groovy",
  "groupproj",
  "grunit",
  "gtmpl",
  "gvimrc",
  "h",
  "haml",
  "hbs",
  "hgignore",
  "hh",
  "hpp",
  "hrl",
  "hs",
  "hta",
  "htaccess",
  "htc",
  "htm",
  "html",
  "htpasswd",
  "hxx",
  "iced",
  "inc",
  "ini",
  "ino",
  "int",
  "irbrc",
  "itcl",
  "itermcolors",
  "itk",
  "jade",
  "java",
  "jhtm",
  "jhtml",
  "js",
  "jscsrc",
  "jshintignore",
  "jshintrc",
  "json",
  "json5",
  "jsonld",
  "jsp",
  "jspx",
  "jsx",
  "ksh",
  "less",
  "lhs",
  "lisp",
  "log",
  "ls",
  "lsp",
  "lua",
  "m",
  "mak",
  "map",
  "markdown",
  "master",
  "md",
  "mdown",
  "mdwn",
  "mdx",
  "metadata",
  "mht",
  "mhtml",
  "mjs",
  "mk",
  "mkd",
  "mkdn",
  "mkdown",
  "ml",
  "mli",
  "mm",
  "mxml",
  "nfm",
  "nfo",
  "njk",
  "noon",
  "npmignore",
  "npmrc",
  "nvmrc",
  "ops",
  "pas",
  "pasm",
  "patch",
  "pbxproj",
  "pch",
  "pem",
  "pg",
  "php",
  "php3",
  "php4",
  "php5",
  "phpt",
  "phtml",
  "pir",
  "pl",
  "pm",
  "pmc",
  "pod",
  "pot",
  "properties",
  "props",
  "pt",
  "pug",
  "py",
  "r",
  "rake",
  "rb",
  "rdoc",
  "rdoc_options",
  "resx",
  "rhtml",
  "rjs",
  "rlib",
  "rmd",
  "ron",
  "rs",
  "rss",
  "rst",
  "rtf",
  "rvmrc",
  "rxml",
  "s",
  "sass",
  "scala",
  "scm",
  "scss",
  "seestyle",
  "sh",
  "shtml",
  "sls",
  "spec",
  "sql",
  "sqlite",
  "ss",
  "sss",
  "st",
  "strings",
  "sty",
  "styl",
  "stylus",
  "sub",
  "sublime-build",
  "sublime-commands",
  "sublime-completions",
  "sublime-keymap",
  "sublime-macro",
  "sublime-menu",
  "sublime-project",
  "sublime-settings",
  "sublime-workspace",
  "sv",
  "svc",
  "svg",
  "t",
  "tcl",
  "tcsh",
  "terminal",
  "tex",
  "text",
  "textile",
  "tg",
  "tmLanguage",
  "tmTheme",
  "tmpl",
  "toml",
  "tpl",
  "ts",
  "tsv",
  "tsx",
  "tt",
  "tt2",
  "ttml",
  "txt",
  "v",
  "vb",
  "vbs",
  "vh",
  "vhd",
  "vhdl",
  "vim",
  "viminfo",
  "vimrc",
  "vue",
  "webapp",
  "wxml",
  "wxss",
  "x-php",
  "xaml",
  "xht",
  "xhtml",
  "xml",
  "xs",
  "xsd",
  "xsl",
  "xslt",
  "yaml",
  "yml",
  "zsh",
  "zshrc"
];
function Cg(A) {
  return A.split("/").pop() || "";
}
function Bg(A, g) {
  if (A) {
    const I = Cg(A).split(".").reverse();
    for (const i of I) {
      if (ig.indexOf(i) !== -1)
        return !0;
      if (Ag.indexOf(i) !== -1)
        return !1;
    }
  }
  return g ? l(g) === "utf8" : null;
}
function l(A, g) {
  if (!A) return null;
  const I = new Uint8Array(A), i = "utf8", C = "binary", B = g?.chunkLength ?? 24;
  let e = g?.chunkBegin ?? 0;
  if (g?.chunkBegin == null) {
    let M = l(A, { chunkLength: B, chunkBegin: e });
    return M === i && (e = Math.max(0, Math.floor(I.length / 2) - B), M = l(A, {
      chunkLength: B,
      chunkBegin: e
    }), M === i && (e = Math.max(0, I.length - B), M = l(A, {
      chunkLength: B,
      chunkBegin: e
    }))), M;
  }
  if (e = eg(I, e), e === -1)
    return C;
  const D = Dg(
    I,
    Math.min(I.length, e + B)
  );
  if (D > I.length)
    return C;
  const w = new TextDecoder("utf-8").decode(I.slice(e, D));
  for (let M = 0; M < w.length; ++M) {
    const S = w.charCodeAt(M);
    if (S === 65533 || S <= 8)
      return C;
  }
  return i;
}
function eg(A, g) {
  if (g === 0)
    return 0;
  if (!wg(A[g]))
    return g;
  let I = g - 3;
  return I >= 0 && c(A[I]) || (I = g - 2, I >= 0 && (c(A[I]) || X(A[I]))) || (I = g - 1, I >= 0 && (c(A[I]) || X(A[I]) || u(A[I]))) ? I : -1;
}
function Dg(A, g) {
  if (g === A.length)
    return g;
  let I = g - 3;
  if (I >= 0 && c(A[I]))
    return g + 1;
  if (I = g - 2, I >= 0) {
    if (c(A[I]))
      return g + 2;
    if (X(A[I]))
      return g + 1;
  }
  if (I = g - 1, I >= 0) {
    if (c(A[I]))
      return g + 3;
    if (X(A[I]))
      return g + 2;
    if (u(A[I]))
      return g + 1;
  }
  return g;
}
function c(A) {
  return A >> 3 === 30;
}
function X(A) {
  return A >> 4 === 14;
}
function u(A) {
  return A >> 5 === 6;
}
function wg(A) {
  return A >> 6 === 2;
}
class yg {
  async init(g) {
    return g === "ipfs" ? await E() : await E();
  }
  async watch(g, I) {
    try {
      const i = new FileSystemObserver(async (e, D) => {
        console.log(">> fs", e, D), I(e);
      }), C = await navigator.storage.getDirectory(), B = !!g && await C.getDirectoryHandle(g);
      return await i.observe(B || C, { recursive: !1 }), i.disconnect;
    } catch (i) {
      return console.error(">> fs [error]", i), !1;
    }
  }
  async getDiskSpace() {
    const { quota: g, usage: I } = await navigator.storage.estimate(), i = g || 0, C = I || 0;
    return { total: i, used: C, free: i - C };
  }
  async openFile(g) {
    const [I] = await window.showOpenFilePicker(g);
    return I;
  }
  async openDirectory(g) {
    const [I] = await window.showDirectoryPicker(g);
    return I;
  }
  async importFile(g) {
    const i = await (await navigator.storage.getDirectory()).getFileHandle(g.name, { create: !0 }), C = await i.createWritable();
    return await (await g.getFile()).stream().pipeTo(C), i;
  }
  async importDirectory(g, I) {
    return await (await navigator.storage.getDirectory()).getDirectoryHandle(I, { create: !0 });
  }
  async hashFile(g, I, i) {
    return `1220${await m.start(g, I, i)}`;
  }
  async cancelHash(g) {
    return m.cancel(g);
  }
  async isTextFile(g, I) {
    return Bg(g, I);
  }
}
let F;
async function og(A) {
  const [g, I] = await N(A);
  if (g instanceof File) {
    const C = await g.arrayBuffer();
    return Buffer.from(C, 0, I);
  }
  const i = new ArrayBuffer(I);
  return g.read(i, { at: 0 }), g.close(), Promise.resolve(Buffer.from(i, 0, I));
}
async function N(A, g = !1) {
  if (typeof A == "string") {
    const I = await k(A);
    if (!I) throw new Error("Unable to get file handle");
    const i = g ? await I.createSyncAccessHandle() : await I.getFile();
    return i instanceof File ? [i, i.size] : [i, i.getSize()];
  }
  return A instanceof FileSystemSyncAccessHandle ? [A, A.getSize()] : [A, A.size];
}
async function k(A, g) {
  const I = await x(), i = [...t.from(A)];
  let C = I, B = i.shift();
  for (; C && B; ) {
    if (i.length > 0)
      try {
        C = await C.getDirectoryHandle(B, g);
      } catch {
        return;
      }
    else
      try {
        return C.getFileHandle(B, g);
      } catch {
        return;
      }
    B = i.shift();
  }
}
async function x() {
  return F || (F = await navigator.storage.getDirectory()), F;
}
const Mg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getFileAccess: N,
  getFileBuffer: og,
  getFileHandle: k,
  getRoot: x
}, Symbol.toStringTag, { value: "Module" })), s = new yg(), tg = s.getDiskSpace, Pg = s.openFile, rg = s.importFile, cg = s.hashFile, sg = s.cancelHash, Sg = s.isTextFile;
export {
  s as FS,
  sg as cancelHash,
  tg as getDiskSpace,
  cg as hashFile,
  rg as importFile,
  Sg as isTextFile,
  Pg as openFile,
  Mg as web
};
